import type { ComponentType } from "react";

export type DevRouteDefinition = {
  path: string;
  load: () => Promise<{ default: ComponentType }>;
};

// Development-only pages. `import.meta.env.DEV` is the only gate: Vite replaces
// it with `false` in production builds, so the dynamic imports drop out of the
// bundle graph.
export const DEV_ROUTES: ReadonlyArray<DevRouteDefinition> = import.meta.env.DEV
  ? [
      { path: "/dev/brand", load: () => import("./pages/dev/BrandLab") },
      {
        path: "/dev/login-admin",
        load: () => import("./pages/dev/AdminLoginLab"),
      },
      { path: "/dev/heroes", load: () => import("./pages/dev/HeroesLab") },
    ]
  : [];
